import React, { useMemo } from 'react';
import styled from 'styled-components';

import { OrderPunctualityType, PunctualityData } from 'apis/merchant-gateway/insights';

import VerticalBarChart from '../charts/VerticalBarChart';
import { Legends } from '../charts/types';

type OperationsPunctualityChartProps = {
  legends: Legends<OrderPunctualityType>;
  data: PunctualityData[];
  summaryKey: string;
};

const OperationsPunctualityChartContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const OperationsPunctualityChart = ({ legends, data, summaryKey }: OperationsPunctualityChartProps) => {
  const chartData = useMemo(() => {
    return data.map(item => {
      const { label, total } = item;
      const { earlyOrders, lateOrders, onTimeOrders } = total;
      return { earlyOrders, lateOrders, onTimeOrders, name: label || '' };
    });
  }, [data]);

  return (
    <OperationsPunctualityChartContainer>
      <VerticalBarChart legends={legends} isStacked data={chartData} summaryKey={summaryKey} />
    </OperationsPunctualityChartContainer>
  );
};

export default OperationsPunctualityChart;
